import { createSelector } from '@reduxjs/toolkit'
import { cartSlice } from '..'

export const activeElementQuotedSeatsAmountSelector = createSelector(
  [cartSlice.selectors.selectedElementQuotableProducts],
  (selectedElementQuotableProducts) => {
    const { b, c, d, m } = selectedElementQuotableProducts
    return [b, c, d, m].reduce((acc, item) => {
      acc = acc + item
      return acc
    })
  }
)
